module.exports = __webpack_public_path__ + "img/Provider.44a71afe.png";